export const distances = [
    "0km",
    "+10km",
    "+20km",
    "+30km",
    "+40km",
    "+50km"
];